
import { Filter } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Project } from "@/types/Project";

interface DashboardHeaderProps {
  selectedProjectId: string | "all";
  setSelectedProjectId: (value: string | "all") => void;
  projects: Project[];
}

export function DashboardHeader({ selectedProjectId, setSelectedProjectId, projects }: DashboardHeaderProps) {
  return (
    <div className="flex items-center gap-3">
      <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
      <div className="flex items-center gap-2 ml-2">
        <div className="flex items-center text-sm text-muted-foreground">
          <Filter className="h-3.5 w-3.5 mr-1" />
          <span>Project:</span>
        </div>
        <Select 
          value={selectedProjectId} 
          onValueChange={(value) => setSelectedProjectId(value as string | "all")}
        >
          <SelectTrigger className="w-[180px] h-9 text-sm">
            <SelectValue placeholder="All projects" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All projects</SelectItem>
            {projects.map((project) => (
              <SelectItem key={project.id} value={project.id}>
                {project.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
